import { Flex } from '../../2022-component-library';
import { Button, colors } from '../../ui';
import { usePostMessage } from '../../context/messageContext';
import { useTestContext } from '../../context/testContext';
import { kaysOptotypes } from '../../helpers/kaysOptotypes';
import { useBreakpoints } from '../../helpers/useBreakpoints';

const OptotypePreview = ({ currentOptotypes, highlightedOptotype }) => {
  const { breakpoints } = useBreakpoints();
  const {
    testData: { optotypesToShow, kaysCrowding },
  } = useTestContext();
  const postMessage = usePostMessage();

  const highlightOptotype = (optotype) => {
    return postMessage({ type: 'useOptotypeReducer', action: 'SET_HIGHLIGHTED_OPTOTYPE', payload: optotype });
  };

  return (
    <Flex
      centered
      style={{ position: 'relative', paddingBottom: highlightedOptotype ? 44 : 0, minHeight: 120 }}
      width='100%'
      maxWidth='100%'
      overflow='auto'
    >
      {highlightedOptotype && (
        <Button variant='secondary' size='sm' style={{ position: 'absolute', bottom: 4 }} onClick={() => highlightOptotype(null)}>
          Clear highlight
        </Button>
      )}
      {currentOptotypes.map((opt, idx) => {
        const sizes = optotypesToShow > 1 ? [100, 125, 200] : [50, 75, 100];
        const previewSize = Math.floor(breakpoints(...sizes) / optotypesToShow);
        return (
          <Flex
            onClick={() => (optotypesToShow > 1 ? highlightOptotype(opt) : null)}
            key={`optotype-${opt}`}
            width={`${previewSize}px`}
            height={`${previewSize}px`}
            style={{
              cursor: optotypesToShow > 1 ? 'pointer' : 'auto',
              backgroundColor: highlightedOptotype === opt ? colors.brand[100] : 'transparent',
              ...(kaysCrowding === 'open' && { margin: `0 ${previewSize / 2}px` }),
              ...(kaysCrowding === 'crowded' && {
                borderStyle: 'solid',
                borderTopWidth: Math.max(Math.floor(0.11 * previewSize), 4),
                borderRightWidth: currentOptotypes.length < 2 || idx > 3 ? Math.max(Math.floor(0.11 * previewSize), 4) : 0,
                borderBottomWidth: Math.max(Math.floor(0.11 * previewSize), 4),
                borderLeftWidth: Math.max(Math.floor(0.11 * previewSize), 4),
                padding: Math.max(Math.floor(0.4 * previewSize), 16),
              }),
            }}
          >
            {kaysOptotypes[opt]}
          </Flex>
        );
      })}
    </Flex>
  );
};

export default OptotypePreview;
